import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, retry, delay, scan, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ISite } from './models/site.model';
import { throwError } from 'rxjs';
import { BASE_URL, END_POINTS } from 'src/app/utility/APIConstants';

@Injectable({ providedIn: "root" })
export class MasterService {
  getoffersforproduct(productId:any) {
    return this._http.get<any[]>(
      `${environment.apiBase}/offer/get/offers/of/product/` + productId
    );
  }
  constructor(private _http: HttpClient) {}

  iseditable() {
    return false;
  }

  // users
  getAllUsers() {
    return this._http.get<any[]>(`${environment.apiBase}/api/user/getAllUsers`);
  }

  getAllActiveUsers() {
    return this._http.get<any[]>(
      `${environment.apiBase}/api/user/getall?isTransaction=true`
    );
  }

  getUsersByRole(roleId:any) {
    return this._http.get<any[]>(
      `${environment.apiBase}/api/user/getall/role/${roleId}`
    );
  }

  getUsersById(userId:any) {
    return this._http.get<any>(
      `${environment.apiBase}/api/user/getById/${userId}`
    );
  }

  addUser(payload:any, file:any): Observable<any> {
    const formData = new FormData();
    // Append payload properties to the FormData
    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        formData.append(key, payload[key]);
      }
    }
    if (file) {
      formData.append("file", file, file.name);
    }
    return this._http.post<any>(
      environment.apiBase + "/api/user/create",
      formData,
      payload
    );
  }

  updateSupplier(payload:any, supplierKey:any): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/supplier/update/" + supplierKey,
      payload
    );
  }



  updateUser(payload:any, id:any): Observable<any> {
    const formData = new FormData();
    // Append payload properties to the FormData
    // for (const key in payload) {
    //     if (payload.hasOwnProperty(key)) {
    //         formData.append(key, payload[key]);
    //     }
    // }

    return this._http.put<any>(
      environment.apiBase + "/api/user/editUserByAdmin/" + id,
      payload
    );
  }

  exportUsers(designation:any, role:any) {
    return this._http.get(
      environment.apiBase + "/api/user/exportUsers/" + designation + "/" + role,
      { responseType: "blob" }
    );
  }

  printUsers(designation:any, role:any) {
    return this._http.get(
      environment.apiBase + "/api/user/printUsers/" + designation + "/" + role,
      { responseType: "blob" }
    );
  }

  deleteUser(id:any): Observable<any> {
    return this._http.delete<any>(environment.apiBase + "/api/user/" + id);
  }

    deleteVendorProductMapping(id): Observable<any> {
    return this._http.delete<any>(environment.apiBase + "/vendor/mapping/" + id);
  }



  activeDeactiveUser(id:any, status:any): Observable<any> {
    return this._http.put<any>(
      environment.apiBase +
        `/api/user/activeDeactiveUser/${id}?status=${status}`,
      {}
    );
  }

  approvalUser(id:any, status:any): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/api/user/approveUser/${id}?status=${status}`,
      {}
    );
  }

  //   District
  getAllDistrict() {
    return this._http.get<any[]>(`${environment.apiBase}/signup/district/all`);
  }
  getAllDistrictById(id) {
    return this._http.get<any[]>(
      `${environment.apiBase}/signup/district/all?stateId=${id}`
    );
  }
  //   Taluka
  getAllTaluka() {
    return this._http.get<any[]>(`${environment.apiBase}/signup/taluka/all`);
  }

  getAllTalukaByDist(distId: any) {
    return this._http.get<any[]>(
      `${environment.apiBase}/signup/taluka/all?district=` + distId
    );
  }
  //   Product

  getAllProductsAgro() {
    return this._http.get<any[]>(
      `${environment.apiBase}/products/get/all/product`,
      {}
    );
  }

  getActiveProductsAgro() {
    return this._http.get<any[]>(
      `${environment.apiBase}/products/get/active/product`,
      {}
    );
  }
  getAllProduct(id: any) {
    return this._http.get<any[]>(
      `${environment.apiBase}/products?export=true&status=true&categoryId=${id}`,
      {}
    );
  }

  getAllProducts(params = {}) {
    return this._http.get<any[]>(`${environment.apiBase}/product/all`, {
      params,
    });
  }

  getAllActiveProducts() {
    return this._http.get<any[]>(
      `${environment.apiBase}/products/get/active/product`
    );
  }

  getKitProducts() {
    return this._http.get<any[]>(
      `${environment.apiBase}/products/get/kit/product/active`
    );
  }

  addProduct(payload): Observable<any> {
    return this._http.post<any>(
      environment.apiBase + "/products/add/product",
      payload
    );
  }

  exportProducts(status) {
    return this._http.get(
      environment.apiBase + "/products/export/products/" + status,
      { responseType: "blob" }
    );
  }

  exportProductsoffer() {
    return this._http.get(
      environment.apiBase + "/offer-category/exportAllOfferCategories",
      { responseType: "blob" }
    );
  }

  printProducts(status:any) {
    return this._http.get(
      environment.apiBase + "/products/print/products/" + status,
      { responseType: "blob" }
    );
  }

  printInvoice(id:any) {
    return this._http.get(environment.apiBase + `/order/print-invoice/${id}`, {
      responseType: "blob",
    });
  }

  addProductByXls(file:any): Observable<any> {
    console.log(file.name);

    return this._http.post<any>(environment.apiBase + "/products/upload", file);
  }

  updateProduct(payload:any): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/products/edit/product",
      payload
    );
  }

  // ---------------------------------------------------------------
  // Customer wallet
  // NOTE: all four endpoint paths below are placeholders - confirm each
  // against Swagger before release.
  // ---------------------------------------------------------------


          /**
   * Transaction / wallet history for a single service.
   * NOTE: endpoint path is a placeholder - confirm against Swagger before release.
   */
  // getServiceTransactionHistory(productId: any): Observable<any> {
  //   return this._http.get<any>(
  //     `${environment.apiBase}/products/transaction/history/${productId}`
  //   );
  // }

  activeDeactiveProduct(id:any): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/products/activate/deactivate/product/` + id,
      {}
    );
  }

  importProduct(file: File): Observable<any> {
    const formData = new FormData();
    if (file) {
      formData.append("file", file, file.name);
    }
    return this._http.post<any>(
      environment.apiBase + "/products/upload",
      formData
    );
  }

  getProductDetailsByID(id): Observable<any> {
    return this._http.get<any>(
      environment.apiBase + `/products/get/product/` + id,
      {}
    );
  }
  getProductsByCategory(id:any): Observable<any> {
    return this._http.get<any>(
      environment.apiBase + `/products/get/product/in/category/` + id,
      {}
    );
  }

  uploadProductimage(formData:any, productId:any): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/products/upload-product-image/" + productId,
      formData
    );
  }

  uploadBaseProductimage(
    formData:any,
    baseProductId:any,
    productType: any
  ): Observable<any> {
    return this._http.put<any>(
      environment.apiBase +
        "/stock/upload-stock-image/" +
        baseProductId +
        "?productType=" +
        productType,
      formData
    );
  }

  addBaseSize(payload:any): Observable<any> {
    return this._http.post<any>(environment.apiBase + `/base-size`, payload);
  }

  updateBaseSize(payload:any): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/base-size`, payload);
  }

  updateBaseSizeMrp(payload:any): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/base-size/state-price`,
      payload
    );
  }

  getAllBaseSizeByBaseId(id:any) {
    return this._http.get<any[]>(`${environment.apiBase}/base-size/` + id, {});
  }

  // State

  getAllStates() {
    return this._http.get<any[]>(
      `${environment.apiBase}/state/get/all/states`,
      {}
    );
  }

  // State
  updateUserAccess(payLoad:any) {
    return this._http.put<any[]>(
      `${environment.apiBase}/role-access/update/multiple/access`,
      payLoad
    );
  }

  //   Stock

  // getAllStock() {
  //   return this._http.get<any[]>(`${environment.apiBase}/stock/get/all/stocks`, {});
  // }

  getAllStock(params = {}) {
    return this._http.get<any[]>(
      `${environment.apiBase}/stock/products?forAdminPanel=true`,
      { params }
    );
  }
  getAllStocks(limit:any) {
    return this._http.get<any[]>(
      `${environment.apiBase}/stock/products?forAdminPanel=true` +
        `&limit=${limit}`
    );
  }

  exportStateWiseProduct(id) {
    return this._http.get(environment.apiBase + "/stock/export/stocks/" + id, {
      responseType: "blob",
    });
  }

  printStateWiseProduct(id) {
    return this._http.get(environment.apiBase + `/stock/print/stocks/` + id, {
      responseType: "blob",
    });
  }

  getAllStocksOfProduct(productId) {
    return this._http.get<any[]>(
      `${environment.apiBase}/stock/get/stocks/of/product/` + productId,
      {}
    );
  }

  addStock(payload): Observable<any> {
    return this._http.post<any>(
      environment.apiBase + "/stock/add/stock",
      payload
    );
  }

  updateStock(id, payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/stock/edit/stock",
      payload
    );
  }

  // getStockProductDetailsByID(id): Observable<any> {
  //   return this._http.get<any>(environment.apiBase + `/stock/get/stocks/of/product/`+id, {})
  // }

  getStockProductDetailsByID(id, forStateSelDisc): Observable<any> {
    return this._http.get<any>(
      environment.apiBase +
        `/stock/product-details?productId=${id}&forStateSelDisc=${forStateSelDisc}`,
      {}
    );
  }

  getBaseSizeByBaseID(baseId): Observable<any> {
    return this._http.get<any>(
      environment.apiBase + `/base-size/` + baseId,
      {}
    );
  }

  getStocknPriceDetailsByID(id): Observable<any> {
    return this._http.get<any>(
      environment.apiBase + `/state-and-price/get/byid/stockandprice/` + id,
      {}
    );
  }

  addSellingStock1(payload): Observable<any> {
    return this._http.post<any>(
      environment.apiBase + "/state-and-price/add/stockandprice",
      payload
    );
  }

  addStateWiseMrp(payload: any) {
    return this._http.post<any>(
      environment.apiBase + "/state-wise-price",
      payload
    );
  }

  updateSellingStock(id, payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/state-and-price/edit/stockandprice",
      payload
    );
  }

  getAllStateWiseProducts(params: String) {
    let url = `${environment.apiBase}/state-wise-price` + params;
    return this._http.get<any[]>(url, {});
  }

  getAll(limit: any) {
    let url = `${environment.apiBase}/base-size/products`;
    url += `?limit=${limit}`;
    return this._http.get<any[]>(url, {});
  }

  getAllBaseService(id: any) {
    let url = `${environment.apiBase}/base-size/products`;
    url += `?pagination=${false}&productId=${id}`;
    return this._http.get<any[]>(url, {});
  }

  exportStateWiseSellingProduct(state, product) {
    return this._http.get(
      environment.apiBase +
        "/state-and-price/export/stock/and/price/" +
        state +
        "/" +
        product,
      { responseType: "blob" }
    );
  }

  printStateWiseSellingProduct(state, product) {
    return this._http.get(
      environment.apiBase +
        "/state-and-price/print/stock/and/price/" +
        state +
        "/" +
        product,
      { responseType: "blob" }
    );
  }

  // product category

  getAllProductCategorys() {
    return this._http.get<any[]>(
      `${environment.apiBase}/category/get/all/category`
    );
  }

  getAllProductCategorysActive() {
    return this._http.get<any[]>(
      `${environment.apiBase}/category/get/active/product/category`
    );
  }

  getAllProductTypes() {
    return this._http.get<any[]>(`${environment.apiBase}/products/types`);
  }
  getAllProductActiveTypes() {
    return this._http.get<any[]>(
      `${environment.apiBase}/products/types?active=true`
    );
  }

  getAllProductCategoryByProductType(sample: any) {
    return this._http.get<any[]>(
      `${environment.apiBase}/category/get/all/category?productType=${sample}`
    );
  }

  exportProductCategory() {
    return this._http.get(
      environment.apiBase + "/category/export/product/categories",
      { responseType: "blob" }
    );
  }

  printProductCategory() {
    return this._http.get(
      environment.apiBase + "/category/print/product/categories",
      { responseType: "blob" }
    );
  }

  getAllActiveProductCategorys() {
    return this._http.get<any[]>(
      `${environment.apiBase}/category/get/active/product/category`
    );
  }

  addProductCategory(payload): Observable<any> {
    return this._http.post<any>(
      environment.apiBase + "/category/add/category",
      payload
    );
  }

  updateProductCategory(id, payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/category/edit/category/" + id,
      payload
    );
  }

  activeDeactiveProductCategory(id): Observable<any> {
    return this._http.put<any>(
      environment.apiBase +
        `/category/activate/deactivate/product/category/` +
        id,
      {}
    );
  }

  deleteProductCategory(id): Observable<any> {
    return this._http
      .delete<any>(environment.apiBase + "/categories/delete/" + id)
      .pipe(catchError(this.handleError));
  }

  uploadCategoryImage(formData, categoryId): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/category/upload-category-image/" + categoryId,
      formData
    );
  }

  uploadTypeImage(formData, transactionKey): Observable<any> {
    return this._http.put<any>(
      environment.apiBase +
        "/products/upload-prod-type-image/" +
        transactionKey,
      formData
    );
  }

  // Sub Category

  getAllSubProductCategorys() {
    return this._http.get<any[]>(
      `${environment.apiBase}/sub-category/get/all/subcategory`
    );
  }

  getSubCategoryByID(id): Observable<any> {
    return this._http.get<any>(
      environment.apiBase +
        `/category/get/active/product/subcategory/by/categoryid/` +
        id,
      {}
    );
  }
  getAllActiveCategory(producType, vendorKey, prodCateId): Observable<any> {
    return this._http.get<any>(
      environment.apiBase +
        `/category/get/active/product/category?prodCategoryId=${prodCateId}&productType=${producType}&vendorKey=${vendorKey}`
    );
  }

  addProductSubCategory(payload): Observable<any> {
    return this._http.post<any>(
      environment.apiBase + "/sub-category/add/subcategory",
      payload
    );
  }

  exportProductSubCategory() {
    return this._http.get(
      environment.apiBase + "/sub-category/export/product/subcategories",
      { responseType: "blob" }
    );
  }

  printProductSubCategory() {
    return this._http.get(
      environment.apiBase + "/sub-category/print/product/subcategories",
      { responseType: "blob" }
    );
  }

  activeDeactiveProductSubCategory(id): Observable<any> {
    return this._http.put<any>(
      environment.apiBase +
        `/sub-category/activate/deactivate/product/subcategory/` +
        id,
      {}
    );
  }

  updateProductSubCategory(id, payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/sub-category/edit/subcategory/" + id,
      payload
    );
  }

  // Rewards

  getAllRewards() {
    return this._http.get<any[]>(
      `${environment.apiBase}/reward/get/all/reward`
    );
  }

  exportOfferRewards() {
    return this._http.get(
      environment.apiBase + "/offer-category/exportAllOfferCategories",
      { responseType: "blob" }
    );
  }
  printRewards() {
    return this._http.get(
      environment.apiBase + "/offer-category/printAllOfferCategories",
      { responseType: "blob" }
    );
  }

  addRewards(payload): Observable<any> {
    return this._http.post<any>(
      environment.apiBase + "/reward/add/reward",
      payload
    );
  }

  updateRewards(payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/reward/edit/reward",
      payload
    );
  }

  activeDeactiveReward(id): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/reward/activate/deactivate/reward/` + id,
      {}
    );
  }

  // Offer category

  getAllOfferCategorys() {
    return this._http.get<any[]>(
      `${environment.apiBase}/offer-category/get/offer/all/category`
    );
  }

  getDiscountOfferCategorys() {
    return this._http.get<any[]>(
      `${environment.apiBase}/offer-category/get/offer/discount/category`
    );
  }

  getActiveproductcatgory() {
    return this._http.get<any[]>(
      `${environment.apiBase}/category/get/active/product/category`
    );
  }
  exportOfferCategories() {
    return this._http.get(
      environment.apiBase + "/offer-category/exportAllOfferCategories",
      { responseType: "blob" }
    );
  }
  printOfferCategories() {
    return this._http.get(
      environment.apiBase + "/offer-category/printAllOfferCategories",
      { responseType: "blob" }
    );
  }

  getAllActiveOfferCategorys() {
    return this._http.get<any[]>(
      `${environment.apiBase}/offer-category/get/active/Offer/category`
    );
  }

  addOfferCategory(payload): Observable<any> {
    return this._http.post<any>(
      environment.apiBase + "/offer-category/add/offer/category",
      payload
    );
  }

  updateOfferCategory(payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/offer-category/edit/offer/category",
      payload
    );
  }

  activeDeactiveOfferCategory(id): Observable<any> {
    return this._http.put<any>(
      environment.apiBase +
        `/offer-category/activate/deactivate/offer/category/` +
        id,
      {}
    );
  }

  deleteOfferCategory(id): Observable<any> {
    return this._http
      .delete<any>(environment.apiBase + "/categories/delete/" + id)
      .pipe(catchError(this.handleError));
  }

  // Offers

  getAllOffers() {
    return this._http.get<any[]>(`${environment.apiBase}/offer/get/all/offers`);
  }

  getOfferDetailByOfferId(id) {
    return this._http.get<any[]>(
      `${environment.apiBase}/offer/get/offerdetails/of/offer/` + id
    );
  }

  exportOffers() {
    return this._http.get(environment.apiBase + "/offer/exportAllOffers", {
      responseType: "blob",
    });
  }

  printOffers() {
    return this._http.get(environment.apiBase + "/offer/printAllOffers", {
      responseType: "blob",
    });
  }

  getProductOffers(id) {
    return this._http.get<any[]>(
      `${environment.apiBase}/offer/get/offers/of/product/` + id
    );
  }

  getAllActiveOffers() {
    return this._http.get<any[]>(
      `${environment.apiBase}/offer/all?isForTrans=true`
    );
  }

  addOffer(payload): Observable<any> {
    return this._http.post<any>(
      environment.apiBase + "/offer/add/offer",
      payload
    );
  }

  updateOffer(payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/offer/edit/offer",
      payload
    );
  }

  deleteOffer(id): Observable<any> {
    return this._http
      .delete<any>(environment.apiBase + "/categories/delete/" + id)
      .pipe(catchError(this.handleError));
  }

  //Discount Offer
  addDiscountOffer(
    studentData: any,
    examCenterCode: any,
    batch: any
  ): Observable<any> {
    return this._http.post<any>(
      environment.apiBase +
        `/studentAbsenty/create?batch=${batch}&examCenterCode=${examCenterCode}`,
      studentData
    );
  }

  //kit combo
  addComboKit(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + "/kit/add/kit", payload);
  }

  getAllKit() {
    return this._http.get<any[]>(`${environment.apiBase}/kit/get/all/kit`);
  }

  updateKit(id, payload): Observable<any> {
    return this._http.put<any>(environment.apiBase + "/kit/edit/kit", payload);
  }

  getKidById(id): Observable<any> {
    return this._http.get<any>(environment.apiBase + `/kit/get/kit/` + id, {});
  }

  getDeatilsBykitQuantityId(kitQuantityId): Observable<any> {
    return this._http.get<any>(
      environment.apiBase +
        `/kit/get/all/kit/quantity/byquantityid/` +
        kitQuantityId,
      {}
    );
  }

  activeDeactiveKit(id): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/kit/activate/deactivate/kit/` + id,
      {}
    );
  }

  exportKits() {
    return this._http.get(environment.apiBase + "/kit/exportAllKits", {
      responseType: "blob",
    });
  }

  printKits() {
    return this._http.get(environment.apiBase + "/kit/printAllKits", {
      responseType: "blob",
    });
  }

  //Add  kit Quantity
  addKitQty(payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/kit/add/quantity/kit`,
      payload
    );
  }

  updateKitQty(payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/kit/update/quantity/kit`,
      payload
    );
  }

  getAllKitQty() {
    return this._http.get<any[]>(
      `${environment.apiBase}/kit/get/all/kit/quantity`
    );
  }

  getAllKitQtyByKitId(id) {
    return this._http.get<any[]>(
      `${environment.apiBase}/kit/get/all/kit/quantity/byid/` + id,
      {}
    );
  }

  //Add Opening Stock
  addOpeningStock(payload): Observable<any> {
    return this._http.post<any>(
      environment.apiBase + `/opening-stock/add/openingstock`,
      payload
    );
  }

  updateOpeningStock(payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/opening-stock/edit/openingstock`,
      payload
    );
  }

  getAllOpeningStock() {
    return this._http.get<any[]>(
      `${environment.apiBase}/opening-stock/get/all/openigstock`
    );
  }

  getAllBatchNames() {
    return this._http.get<any[]>(
      `${environment.apiBase}/opening-stock/get/all/batchnames`
    );
  }

  getAllBatchNamesOfProduct(id) {
    return this._http.get<any[]>(
      `${environment.apiBase}/opening-stock/get/all/batchnames/ofproduct/` + id,
      {}
    );
  }

  getAllOpenningStockByProductId(id) {
    return this._http.get<any[]>(
      `${environment.apiBase}/opening-stock/get/all/openigstock/byproductid/` +
        id,
      {}
    );
  }

  importOpeningStock(file: File): Observable<any> {
    const formData = new FormData();
    if (file) {
      formData.append("file", file, file.name);
    }
    return this._http.post<any>(
      environment.apiBase + "/opening-stock/upload",
      formData
    );
  }

  exportOpeningStock() {
    return this._http.get(
      environment.apiBase + "/opening-stock/exportAllOpeningStock",
      { responseType: "blob" }
    );
  }

  printOpeningStock() {
    return this._http.get(
      environment.apiBase + "/opening-stock/printAllOpeningStock",
      { responseType: "blob" }
    );
  }

  // video instegarted

  getAllIntegratedVideo() {
    return this._http.get<any[]>(
      `${environment.apiBase}/integrated-video/get/all/integrated/video`
    );
  }

  addIntegratedVideo(formData): Observable<any> {
    return this._http.post<any>(
      environment.apiBase + "/integrated-video/add/integrated/video",
      formData
    );
  }

  updateIntegratedVideo(id, formData): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/integrated-video/edit/integrated/video",
      formData
    );
  }
  activeDeactiveVideo(id): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/integrated-video/activate/deactivate/video/` + id,
      {}
    );
  }

  // crops

  getAllCrops() {
    return this._http.get<any[]>(`${environment.apiBase}/crop/get/all/crops`);
  }

  createCrop(payload): Observable<any> {
    return this._http.post<any>(
      environment.apiBase + "/crop/add/crop",
      payload
    );
  }

  updateCrop(payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/crop/edit/crop",
      payload
    );
  }

  activeDeactiveCrop(id): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/crop/activate/deactivate/crop/` + id,
      {}
    );
  }

  exportCrop() {
    return this._http.get(environment.apiBase + "/crop/exportAllCrop", {
      responseType: "blob",
    });
  }

  printCrop() {
    return this._http.get(environment.apiBase + "/crop/printAllCrop", {
      responseType: "blob",
    });
  }

  uploadCropimage(formData, cropId): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/crop/upload-crop-image/" + cropId,
      formData
    );
  }

  // crops category

  getAllCropCategorys() {
    return this._http.get<any[]>(
      `${environment.apiBase}/crop-category/get/all/crop/category`
    );
  }

  getAllActiveCropCategorys() {
    return this._http.get<any[]>(
      `${environment.apiBase}/crop-category/get/all/active/crop/category`
    );
  }

  createCropCategory(payload): Observable<any> {
    return this._http.post<any>(
      environment.apiBase + "/crop-category/add/crop/category",
      payload
    );
  }

  updateCropCategory(payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/crop-category/edit/crop/category",
      payload
    );
  }

  activeDeactiveCropCategory(id): Observable<any> {
    return this._http.put<any>(
      environment.apiBase +
        `/crop-category/activate/deactivate/crop/category/` +
        id,
      {}
    );
  }

  exportCropCategory() {
    return this._http.get(
      environment.apiBase + "/crop-category/exportAllCropCategory",
      { responseType: "blob" }
    );
  }

  printCropCategory() {
    return this._http.get(
      environment.apiBase + "/crop-category/printAllCropCategory",
      { responseType: "blob" }
    );
  }

  addNewSequenceItem(payload): Observable<any> {
    return this._http.post(environment.apiBase + "/orderSequence", payload);
  }

  updateSequenceItem(id, payload): Observable<any> {
    return this._http.put(
      environment.apiBase + `/orderSequence/update/${id}`,
      payload
    );
  }

  deleteSequence(id): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/orderSequence/updatestatus/" + id,
      {}
    );
  }

  getSequenceData(): Observable<any> {
    return this._http.get(environment.apiBase + "/orderSequence");
  }

  addNewContractorItem(payload): Observable<any> {
    return this._http.post(environment.apiBase + "/contractor/create", payload);
  }

  updateContractorItem(id, payload): Observable<any> {
    return this._http.put(
      environment.apiBase + `/contractor/update/${id}`,
      payload
    );
  }

  deleteContractor(id, status): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/contractor/status/${id}?status=${status}`,
      {}
    );
  }

  getAllContractor(): Observable<any> {
    return this._http.get(environment.apiBase + "/contractor/all");
  }
  updateWorkOrder(id, payload): Observable<any> {
    return this._http.put(
      environment.apiBase + `/workorder/update/${id}`,
      payload
    );
  }

  getSiteData(): Observable<any> {
    return this._http.get<ISite[]>(
      environment.apiBase + "/sitescontroller/getall"
    );
  }

  getAllActiveSiteData(): Observable<any> {
    return this._http.get<ISite[]>(
      environment.apiBase + "/sitescontroller/getall?isForTrans=true"
    );
  }

  getSiteByClientId(clientKey): Observable<any> {
    return this._http.get<ISite[]>(
      environment.apiBase +
        `/sitescontroller/getall?clientKey=${clientKey}&isForTrans=true`
    );
  }

  updateSite(id, payload): Observable<any> {
    return this._http.put(
      environment.apiBase + `/client/addsite/${id}`,
      payload
    );
  }

  createSite(payload): Observable<any> {
    return this._http.post(
      environment.apiBase + `/sitescontroller/create`,
      payload
    );
  }

  deleteSite(id, status): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/sitescontroller/status/${id}?status=${status}`,
      {}
    );
  }

  // deleteSite(id): Observable<any> {
  //   return this._http.delete<any>(environment.apiBase + '/sitescontroller/delete/' + id)
  // }

  updateSiteByClientId(clientId, siteId, payload): Observable<any> {
    return this._http.put(
      environment.apiBase +
        `/sitescontroller/update/client/${clientId}/site/${siteId}`,
      payload
    );
  }
  // uom

  getAlluom(): Observable<any> {
    return this._http.get(environment.apiBase + "/uom/get/all/uom");
  }

  getAllActiveuom(): Observable<any> {
    return this._http.get(environment.apiBase + "/uom/get/active/uom");
  }

  addUOM(payload): Observable<any> {
    return this._http.post(environment.apiBase + "/uom/add/uom", payload);
  }

  updateUOM(payload, id): Observable<any> {
    return this._http.put(environment.apiBase + "/uom/edit/uom", payload);
  }

  activeDeactiveUOM(id): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/uom/activate/deactivate/uom/` + id,
      {}
    );
  }

  deleteUOM(id): Observable<any> {
    return this._http
      .delete<any>(environment.apiBase + "/uom/delete/" + id)
      .pipe(catchError(this.handleError));
  }

  // role
  getAllRoles() {
    return this._http.get<any[]>(`${environment.apiBase}/roles/all`);
  }

  getAllMapping() {
    return this._http.get<any[]>(`${environment.apiBase}/vendor/mapping`);
  }

  getVendoryById(id:any,catId:any): Observable<any> {
    return this._http.get<any[]>(`${environment.apiBase}/vendor/${id}/products?productCategoryId=${catId}`);
  }

  getAllVendorse(params) {
    const { limit, pageNo, searchText } = params;
    return this._http.get<any[]>(
      `${environment.apiBase}/vendor?limit=${limit}&pageNo=${pageNo}&searchText=${searchText}`
    );
  }

  getAllVendors() {
    return this._http.get<any[]>(`${environment.apiBase}/vendor`);
  }

  getAllVendorshortInfo() {
    return this._http.get<any[]>(`${environment.apiBase}/vendor/short-info?approvalStatus=APPROVED&isApproved=1`);
  }

  getAllMappedServiceProvider(orderId:any) {
    return this._http.get<any[]>(`${environment.apiBase}/order/${orderId}/service-providers`);
  }

  getVendorProductCategories(id) {
    return this._http.get<any[]>( `${environment.apiBase}/vendor/${id}/product-categories`
    );
  }

  getVendorProduct(id) {
    return this._http.get<any[]>(
      `${environment.apiBase}/products/get/product/in/category/${id}`
    );
  }
  exportRoles() {
    return this._http.get(environment.apiBase + "/roles/exportRoles", {
      responseType: "blob",
    });
  }

  printRoles() {
    return this._http.get(environment.apiBase + "/roles/printRoles", {
      responseType: "blob",
    });
  }

  getAllActiveRoles() {
    return this._http.get<any[]>(
      `${environment.apiBase}/roles/all?isTransaction=true`
    );
  }

  createRole(payload): Observable<any[]> {
    return this._http.post<any>(
      environment.apiBase + "/roles/add/role",
      payload
    );
  }
  createMapping(payload): Observable<any[]> {
    return this._http.post<any>(
      environment.apiBase + "/vendor/mapping",
      payload
    );
  }

  createServiceTye(payload): Observable<any[]> {
    return this._http.post<any>(
      environment.apiBase + "/product-types",
      payload
    );
  }

  createVendor(payload): Observable<any> {
    return this._http.post(environment.apiBase + "/vendor", payload);
  }
  updateRole(payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/roles/update/role",
      payload
    );
  }

  updateCustomer(payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/api/user/edituser",
      payload
    );
  }

  updateServiceType(id, payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/product-types/${id}`,
      payload
    );
  }
  updateVendor(payload, id: number): Observable<any> {
    return this._http.put<any>(environment.apiBase + "/vendor/" + id, payload);
  }

  activeDeactiveRole(id, status): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/roles/status/${id}?status=${status}`,
      {}
    );
  }

  activeDeactiveServiceType(id, status): Observable<any> {
    return this._http.patch<any>(
      environment.apiBase + `/product-types/${id}/status?active=${status}`,
      {}
    );
  }

  // expense
  getAllExpense() {
    return this._http.get<any[]>(`${environment.apiBase}/expense/all`);
  }

  addExpense(payload): Observable<any> {
    return this._http.post<any>(
      environment.apiBase + `/expense/create`,
      payload
    );
  }

  updateExpense(id, payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/expense/update/${id}`,
      payload
    );
  }

  deleteExpenseType(id): Observable<any> {
    return this._http.delete<any>(
      environment.apiBase + "/expense/delete/" + id
    );
  }

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  /**
   * @description This API returns list of work type
   **/
  fetchWorkTypes = (): Observable<any> => {
    return this._http.get(BASE_URL + END_POINTS.WORK_TYPE.FETCH);
  };

  addWorkType(payload): Observable<any> {
    return this._http.post<any>(
      environment.apiBase + `/worktype/create`,
      payload
    );
  }

  updateWorkType(id, payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/worktype/update/${id}`,
      payload
    );
  }
  deleteWorkType(id): Observable<any> {
    return this._http
      .delete<any>(environment.apiBase + "/worktype/delete/" + id)
      .pipe(catchError(this.handleError));
  }

  //  get boq entry by site id

  getBoqBySiteKey(id): Observable<any> {
    return this._http.get<any>(
      environment.apiBase + `/boqentry/get?siteKey=${id}`
    );
  }

  // Gst Master
  getAllGst(): Observable<any> {
    return this._http.get<any>(environment.apiBase + `/gst_master/all`);
  }

  // users
  getAllBanks() {
    return this._http.get<any[]>(`${environment.apiBase}/bank/all`);
  }

  addBank(payload): Observable<any> {
    return this._http.post<any>(environment.apiBase + "/bank/create", payload);
  }

  updateBank(payload, id): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/bank/update/" + id,
      payload
    );
  }

  activateDeactivatebank(id, status): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/bank/status/${id}?status=${status}`,
      {}
    );
  }

  deleteBank(id): Observable<any> {
    return this._http.delete<any>(environment.apiBase + "/bank/delete/" + id);
  }

  // make master

  getAllMakes(): Observable<any> {
    return this._http.get<any>(environment.apiBase + "/makemaster/all");
  }

  getAllActiveMakes(): Observable<any> {
    return this._http.get<any>(
      environment.apiBase + `/makemaster/all?isTransaction=true`
    );
  }

  addMake(payLoad): Observable<any> {
    return this._http.post<any>(
      environment.apiBase + "/makemaster/create",
      payLoad
    );
  }

  updateMake(id, payLoad): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/makemaster/update/${id}`,
      payLoad
    );
  }

  updateMakeStatus(id): Observable<any> {
    return this._http.get<any>(
      environment.apiBase + `/makemaster/make-status?id=${id}`
    );
  }

  // t&c master

  createTAC(payload): Observable<any> {
    return this._http.post<any>(
      environment.apiBase + "/epterms/create",
      payload
    );
  }

  updateTAC(id, payLoad): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/epterms/update/${id}`,
      payLoad
    );
  }

  getAllTAC(): Observable<any> {
    return this._http.get<any>(environment.apiBase + "/epterms/all");
  }

  deleteTAC(id): Observable<any> {
    return this._http.delete<any>(
      environment.apiBase + "/epterms/delete/" + id
    );
  }

  // Tower

  getAllTowers(): Observable<any> {
    return this._http.get<any>(environment.apiBase + "/tower/all");
  }

  addTower(payLoad): Observable<any> {
    return this._http.post<any>(environment.apiBase + "/tower/create", payLoad);
  }

    
  notifyfunction(id): Observable<any> {
    return this._http.post<any>(`${environment.apiBase}/notifications/send-to-user?message=${'New Order Assign To You'}&title=${'New Order'}&type=SYSTEM&userId=${id}`,{});
  }

  updateTower(id, payLoad): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/tower/update/${id}`,
      payLoad
    );
  }

  // taluka

  getAlltaluka(): Observable<any> {
    return this._http.get(environment.apiBase + "/signup/taluka/all");
  }

  addTaluka(payLoad): Observable<any> {
    return this._http.post<any>(
      environment.apiBase + "/signup/taluka/create",
      payLoad
    );
  }

  updateTaluka(payload, id): Observable<any> {
    return this._http.put(
      environment.apiBase + "/signup/taluka/update/" + id,
      payload
    );
  }

  //brand
  getAllBrands() {
    return this._http.get<any[]>(`${environment.apiBase}/brand`);
  }

  exportBrands() {
    return this._http.get(environment.apiBase + "/brand/exportRoles", {
      responseType: "blob",
    });
  }

  printBrands() {
    return this._http.get(environment.apiBase + "/brand/printRoles", {
      responseType: "blob",
    });
  }

  createBrand(payload): Observable<any[]> {
    return this._http.post<any>(environment.apiBase + "/brand", payload);
  }

  updateBrand(id, payload): Observable<any> {
    return this._http.put<any>(environment.apiBase + `/brand/${id}`, payload);
  }

  activeDeactiveBrand(id, status): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/brand/status/${id}?status=${status}`,
      {}
    );
  }

  uploadBrandimage(formData, brandId): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/brand/upload-brand-image/" + brandId,
      formData
    );
  }

  uploadKitimage(formData, kitId): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/kit/upload-kit-image/" + kitId,
      formData
    );
  }

  // warehouse
  getAllWarehouse() {
    return this._http.get<any[]>(`${environment.apiBase}/warehouse`);
  }

  exportWarehouse() {
    return this._http.get(environment.apiBase + "/warehouse/exportRoles", {
      responseType: "blob",
    });
  }

  printWarehouse() {
    return this._http.get(environment.apiBase + "/warehouse/printRoles", {
      responseType: "blob",
    });
  }

  getAllActiveWarehouse() {
    return this._http.get<any[]>(
      `${environment.apiBase}/warehouse/all?isTransaction=true`
    );
  }

  getWarehouseById(whId: any) {
    return this._http.get<any[]>(`${environment.apiBase}/warehouse/` + whId);
  }

  createWarehouse(payload): Observable<any[]> {
    return this._http.post<any>(environment.apiBase + "/warehouse", payload);
  }

  updateWarehouse(id, payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/warehouse/${id}`,
      payload
    );
  }

  activeDeactiveWarehouse(id, status): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/warehouse/status/${id}?status=${status}`,
      {}
    );
  }

  // advertisement
  getAllAdvertisement() {
    return this._http.get<any[]>(`${environment.apiBase}/advertise/all`);
  }

  createAdvertisement(payload): Observable<any[]> {
    return this._http.post<any>(
      environment.apiBase + "/advertise/create",
      payload
    );
  }

  updateAdvertisement(id, payload): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/advertise/update/${id}`,
      payload
    );
  }

  activeDeactiveAdvertisement(id): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/advertise/active-deactive/${id}`,
      {}
    );
  }

  activeDeactiveCutomerlist(id): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + `/api/user/activeDeactiveUser/${id}`,
      {}
    );
  }
  uploadadvimage(formData, advId): Observable<any> {
    return this._http.put<any>(
      environment.apiBase + "/advertise/upload-image/" + advId,
      formData
    );
  }

  getVendorById(id: number) {
    return this._http.get(`${environment.apiBase}/vendor/${id}`);
  }

  updateVendorOnes(id: number, payload: FormData) {
    return this._http.put(`${environment.apiBase}/vendor/${id}`, payload);
  }
AssignOreder(orderId: number, payload: any) {
   console.log("Service orderId =", orderId);
  return this._http.put(`${environment.apiBase}/order/${orderId}/status`,payload);
}



  downloadkycfiles(filename: any) {
    return this._http.get(
      `${environment.apiBase}/vendor/download?fileName=${filename}`,
      { responseType: "blob" }
    );
  }

  // ---------------------------------------------------------------
  // KYC
  // ---------------------------------------------------------------

  /** GET /kyc/{id} - full KYC record including document paths. */
  getKycById(id: number) {
    return this._http.get<any>(`${environment.apiBase}/kyc/${id}`);
  }

  /**
   * PUT /kyc/{id}/status
   * Body: { kycStatus: "APPROVED" | "PENDING" | "REJECTED", kycRejectReason }
   */
  updateKycStatus(id: number, payload: any) {
    return this._http.put<any>(
      `${environment.apiBase}/kyc/${id}/status`,
      payload
    );
  }

    getWalletHistory(walletId: number) {
    return this._http.get(`${environment.apiBase}/wallets/history/${walletId}`);
  }

    ViewWalletBalance(id: number) {
    return this._http.get(`${environment.apiBase}/wallets/user/${id}`);
  }


    updateWalletBalnce(walletId: number, payload: FormData) {
    return this._http.put(`${environment.apiBase}/wallets/history/${walletId}`, payload);
  }
}



